import { StatusColor } from './status-color';

export enum DeparaStatus {
  'Finalizado' = StatusColor.Finished,
  'Em progresso' = StatusColor.Progress,
  'Enviado' = StatusColor.Send,
  'Não enviado' = StatusColor.Hanging,
  'Erro(s)' = StatusColor.Error,
}
